function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.math.sign.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//Global variables
window.lm = {};
// window.ajaxCall = [];

// Commanders act variable for tracking system
window.tc_vars = {};
import 'integration-web-core--socle/js/assets/commons/_delegateEvent.js';
import { activeModules, kobiEvents, Composant } from 'integration-web-core--socle/js/assets/commons/_common.js';
import { lmFetch } from 'integration-web-core--socle/js/assets/commons/_fetch.js';
import { cookie } from 'integration-web-core--socle/js/assets/commons/_cookie.js';
import { localStorageLM } from 'integration-web-core--socle/js/assets/commons/_localStorage.js';
import { template } from 'integration-web-core--socle/js/assets/commons/_template.js';
import { DOMReady } from 'integration-web-core--socle/js/assets/commons/_domReady.js';
import { init as initLazyload } from 'integration-web-core--socle/js/assets/commons/_lazyload.js';
import { EventBus, IntersectionObserverService } from '@adeo/kobi--front-helpers';

//Polyfill for Math.sign
if (!Math.sign) Math.sign = function (x) {
  return (x > 0) - (x < 0) || +x;
};

// Expose needed stuff to lm global variables
lm.Composant = Composant;
lm.modules = activeModules;
lm.events = kobiEvents;
lm.fetch = lmFetch;
lm.cookie = cookie;
lm.localStorageLM = localStorageLM;
lm.template = template;
lm.lazyload = null;
lm.DOMReady = DOMReady;
var Sentry = /*#__PURE__*/function () {
  function Sentry() {
    _classCallCheck(this, Sentry);
  }
  return _createClass(Sentry, [{
    key: "configureScope",
    value: function configureScope() {
      return null;
    }
  }]);
}();
lm.sentry = new Sentry();

// Init localStorageLM inside global variable
lm.localStorageLM.init();
lm.DOMReady(function () {
  // Init lazy-loading
  lm.lazyload = initLazyload('.lazy, [loading=lazy]');
  lm.lazyload.observe();
  var cssAsync = document.querySelectorAll('link.lazy-src');
  var _iterator = _createForOfIteratorHelper(cssAsync),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cAsync = _step.value;
      cAsync.href = cAsync.dataset.href;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var jsAsync = document.querySelectorAll('script.lazy-src');
  var _iterator2 = _createForOfIteratorHelper(jsAsync),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var jAsync = _step2.value;
      jAsync.src = jAsync.dataset.src;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
});

// Keep track of common.js execution through webperf reporting
if (performance.mark !== undefined) {
  performance.mark('Common.js has run');
}
lm.MobileAppBridge = function (action, value) {
  return new Promise(function (res, rej) {
    // Android part
    if ((typeof CustomerMobileAppWebBridge === "undefined" ? "undefined" : _typeof(CustomerMobileAppWebBridge)) === 'object') {
      res(CustomerMobileAppWebBridge.sendEvent(action, value));
    }

    // iOS part
    else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.customerMobileAppSendEvent) {
      var message = {
        command: action,
        parameters: {
          'param': value
        }
      };
      window.webkit.messageHandlers.customerMobileAppSendEvent.postMessage(message).then(function () {
        return res(true);
      })["catch"](function () {
        return rej();
      });
    } else res(false);
  });
};
var eventBus = new EventBus('NewsLetterPopin');
var NewsLetterPopin = {
  /**
   * Set the condition to show the popin
   * @param {Object} data - Data to be sent to the news letter popin component
   * @example lm.NewsLetterPopin.setTrigger({type: 'callingShort'}) // Show the popin after a short time (10s)
   * @example lm.NewsLetterPopin.setTrigger({type: 'callingLong'}) // Show the popin after a long time (30s)
   */
  setTrigger: function setTrigger(data) {
    eventBus.emit('triggerPopinCondition', data);
  },
  /**
   * Add a listener to the event bus to implement the logic to show the popin
   * @param {Function} callback - Function to be called when the popin is shown
   * @example lm.NewsLetterPopin.listening((data) => { console.log(data) }) // Log the data sent to trigger the popin
   */
  listening: function listening(callback) {
    eventBus.on('triggerPopinCondition', function (data) {
      return callback(data.detail);
    });
  }
};
lm.NewsLetterPopin = NewsLetterPopin;
if (!window.fragmentLazyLoad) {
  window.fragmentLazyLoad = new IntersectionObserverService({
    root: null,
    rootMargin: '10%',
    threshold: 0.0
  }) // Intersection Observer API options
  ;
  window['lazy-loading-bus'].on("fragmentLoaded", function () {
    lm.lazyload = initLazyload('.lazy, [loading=lazy]');
    lm.lazyload.observe();
  });
}